import { sdk } from 'src/utilities/sdk';
import { camelizeResponseData } from 'src/utilities/http-data-casing';
import {
  OnboardingFunnelDetails,
  OnboardingFunnelDetailsResponse,
} from 'src/components/enterprise/features/HomePage/types/OnboardingFunnel';

export const getOnboardingFunnelEndpoint = (corpId: string): string =>
  `/corp-admin/corp/premium/${corpId}/onboarding-funnel/refresh`;

export async function getOnboardingFunnelStatus(
  corpId: string
): Promise<OnboardingFunnelDetails> {
  const response: OnboardingFunnelDetailsResponse = await sdk.http.post(
    getOnboardingFunnelEndpoint(corpId),
    {}
  );

  return camelizeResponseData(response);
}
